import React from 'react';
import { observer } from 'mobx-react';

import classNames from 'classnames';
import classes from './ClientsInfoItem.module.scss';
import { DiffPercentLabel } from '../../../shared/components/ui-components/DiffPercentLabel/DiffPercentLabel';
import { entityDashboardFilterStore } from '../../stores/entityDashboardFilterStore';
import { getComparisonPeriodForPreset } from '../../../shared/utils/getComparisonPeriodForPreset/getComparisonPeriodForPreset';

type IndicatorColor = 'info-400' | 'info-300' | 'info-200' | 'info-100' | 'violet-100';

type ClientsInfoItemProps = {
  title: string;
  value: number;
  diffPercent?: number;
  indicatorColor?: IndicatorColor;
  hideComparisonPeriod?: boolean;
};

const ClientsInfoItem = observer(
  ({
    title,
    value,
    diffPercent,
    indicatorColor,
    hideComparisonPeriod,
  }: ClientsInfoItemProps) => {
    const { dateRangePreset } = entityDashboardFilterStore;

    const markerClass = classNames(
      classes.marker,
      indicatorColor && classes[indicatorColor],
    );

    return (
      <div className={classes.container}>
        {indicatorColor && <span className={markerClass} />}
        <div className={classes.infoContainer}>
          <p className={classes.title}>{title}</p>
          <div className={classes.valueRow}>
            <p className={classes.value}>{value}</p>
            {!!diffPercent && (
              <div className={classes.comparisonRow}>
                <DiffPercentLabel percentValue={diffPercent} />
                {!hideComparisonPeriod && (
                  <p className={classes.period}>
                    vs {getComparisonPeriodForPreset(dateRangePreset)}
                  </p>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  },
);

export { ClientsInfoItem };
